import React, { useState, useEffect, useMemo } from "react";
import Approved from "./Assets/Approved";
import Rejected from "./Assets/RejectModel";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const DeleteRequest = () => {
  const [deleteRequest, setDeleteRequest] = useState([]);
  const [userRoles, setUserRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [daysFilter, setDaysFilter] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rejectModalShow, setRejectModalShow] = useState(false);
  const [approvedModalShow, setApprovedModalShow] = useState(false);
  const [itemToApprove, setItemToApprove] = useState(null);
  const [itemToReject, setItemToReject] = useState(null);
  const itemsPerPage = 30;
    const navigate = useNavigate();
  const Auth = localStorage.getItem("authToken");

  useEffect(() => {
    fetchTasks();
  }, []);
// fetch al data
  const fetchTasks = async () => {
    try {
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/get-data-list", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Auth}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch tasks");

      const result = await response.json();
      setUserRoles(result.roles || []);
      setDeleteRequest(result.delete_requests || []);
      
      
      setLoading(false);
    } catch (err) {
      console.error("Error fetching tasks:", err);
      setError(err.message);
      setLoading(false);
    }
  };

    const getRoleName = (id) => {
        const role = userRoles.find((r) => r.id === id);
        return role ? role.role_name : `Role ID: ${id}`;
    };
  

  
  const filteredRequest = useMemo(() => {
    const today = new Date();

    let filtered = deleteRequest.filter((d) => {
      const nameMatch = d.name?.toLowerCase().includes(search.toLowerCase());

      let matchesDate = true;
      if (daysFilter) {
        const createdDate = new Date(d.created_at);
        if (!isNaN(createdDate)) {
          const diffTime = today - createdDate;
          const diffDays = diffTime / (1000 * 60 * 60 * 24);
          matchesDate = diffDays <= parseInt(daysFilter);
        } else {
          matchesDate = false;
        }
      }

      return nameMatch && matchesDate;
    });

    
    if (sortOption === "name-asc") {
      filtered.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    } else if (sortOption === "name-desc") {
      filtered.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
    } else if (sortOption === "date-asc") {
      filtered.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );
    } else if (sortOption === "date-desc") {
      filtered.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    }

    return filtered;
  }, [deleteRequest, search, daysFilter, sortOption]);

  // Pagination method
  const totalPages = Math.ceil(filteredRequest.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentRequests = filteredRequest.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
const handleRejectClick = (id) => {
    setItemToReject(id);
    setRejectModalShow(true);
  };

  const confirmReject = async () => {
    try {
      const response = await fetch(`https://backend.sanchalansetu.com/api/v1/user/rejectrequest/${itemToReject}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        }  
      });

      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to delete task: ${errorText}`);
      }
      const errorText = await response.json();
      alert("Delete Request Rejected");
    } catch (error) {
      console.error("Error deleting task:", error);
    }
    fetchTasks();
    setRejectModalShow(false);
    setItemToReject(null);

  };

  const cancelReject = () => {
    setRejectModalShow(false);
    setItemToReject(null);
  };

  const handleApproveClick = (id) => {
    setItemToApprove(id);
    setApprovedModalShow(true);
  };

  const confirmApprove = async () => {
    try {

      const response = await fetch(`https://backend.sanchalansetu.com/api/v1/users/delete/${itemToApprove}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        }  
      });

      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to delete task: ${errorText}`);
      }
      const errorText = await response.json();
      alert("Request Approved Successfully");
    } catch (error) {
      console.error("Error deleting task:", error);
    }
    fetchTasks();
    setApprovedModalShow(false);
    setItemToApprove(null);

  };

  const cancelApprove = () => {
    setApprovedModalShow(false);
    setItemToApprove(null);
  };



  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;


  return (
    <div className="Task-Details-Container">
      <h2 className="text-xl font-semibold mb-4">Delete Request List</h2>

      
      <div className="flex justify-end flex-wrap gap-4 mb-4">
        <input
          type="text"
          placeholder="Search by Name..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="px-4 py-2 border rounded"
        />

        <select
          value={daysFilter}
          onChange={(e) => {
            setDaysFilter(e.target.value);
            setCurrentPage(1);
          }}
          className="px-2 py-1 border rounded"
        >
          <option value="">All Dates</option>
          <option value="1">Last 1 Day</option>
          <option value="7">Last 7 Days</option>
          <option value="30">Last 30 Days</option>
          <option value="182">Last 6 Months</option>
          <option value="365">Last 1 Year</option>
        </select>

        <select
          value={sortOption}
          onChange={(e) => {
            setSortOption(e.target.value);
            setCurrentPage(1);
          }}
          className="px-2 py-1 border rounded"
        >
          <option value="">Sort None</option>
          <option value="name-asc">Name Asc</option>
          <option value="name-desc">Name Desc</option>
          <option value="date-asc">Date Asc</option>
          <option value="date-desc">Date Desc</option>
        </select>
      </div>

      
      <table className="w-full text-sm border user-table">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2 text-left">#</th>
                  <th className="px-4 py-2 text-left">Name</th>
                  <th className="px-4 py-2 text-left">Email</th>
                  <th className="px-4 py-2 text-left">Role</th>
                  <th className="px-4 py-2 text-left">Created At</th>
                  <th className="px-4 py-2 text-left">Action</th>
                </tr>
              </thead>
              <tbody>
                {currentRequests.length > 0 ? (
                  currentRequests.map((u, index) => (
                    <tr key={u.id || index} className="border-t">
                      <td className="px-4 py-2">{startIndex + index + 1}</td>
                      <td className="px-4 py-2">{u.name || "N/A"}</td>
                      <td className="px-4 py-2">{u.email || "N/A"}</td>
                      <td className="px-4 py-2">{getRoleName(u.role) || "N/A"}</td>
                      <td className="px-4 py-2">{formatDateTime(u.created_at || u.createdAt)}</td>
                      <td className="px-4 py-2 flex gap-2 flex-wrap">
                        <button className="text-white bg-green-500 hover:bg-green-700 p-2 rounded" onClick={() => handleApproveClick(u.id)}>
                          Approve
                        </button>
                        <button className="text-white bg-red-500 hover:bg-red-700 p-2 rounded" onClick={() => handleRejectClick(u.id)}>
                          Reject
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-4 text-gray-500">
                      No users found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
      

      
      <div className="flex justify-center mt-4 gap-2 items-center">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <span className="ml-4 text-sm text-gray-600">
          Page {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
      {rejectModalShow && (
        <Rejected
          itemName={
            currentRequests.find((p) => p.id === itemToReject)?.name || "Unknown Name"
          }
          onClose={cancelReject}
          onDelete={confirmReject}
        />
      )}
      {approvedModalShow && (
        <Approved
          itemName={
            currentRequests.find((p) => p.id === itemToApprove)?.name || "Unknown Name"
          }
          onClose={cancelApprove}
          onDelete={confirmApprove}
        />
      )}
    </div>
  );
};

export default DeleteRequest;


const formatDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return isNaN(date.getTime()) ? "" : date.toLocaleString();
};
